// extracted by mini-css-extract-plugin
export default {"container":"comingSoon_container__tx8de","logo":"comingSoon_logo__vueFU"};